import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { CustomCalendar } from '../../components/Input/CustomCalendar'
import { SelectElement } from '../../components/FormElement/SelectElement'
import GeneralButton from '../../components/Button/GeneralButton'
import { IZoneForm,ZoneError } from '../../models/Phase3/Zone'
import { SelectListOption } from '../../models/Pharse2/Graph'
import { useStore } from '../../stores/store'

interface Prop {
	record: IZoneForm
	setRecord: (arr: IZoneForm) => void
	setZone: (zone: number[] | undefined) => void
}
export default observer(function ZoneForm({ record, setRecord, setZone }: Prop) {
	const [errors, setErrors] = useState<ZoneError>(new ZoneError());
	const [projectOptions, setProjectOptions] = useState<SelectListOption[]>([])
	const [locationOptions, setLocationOptions] = useState<SelectListOption[]>([])
	const { zoneStore, graphStore } = useStore();
	const ZoneFormValidation = (form: IZoneForm) => {
		const error: ZoneError = new ZoneError()
	
		if (form.projectId === undefined || form.projectId === -1) {
			error.projectId = true
		}
		return error;
	
	
	}
    const handleUpdate = () => {
        var newError = ZoneFormValidation(record);
        setErrors(newError);
        if (Object.values(newError).some((item) => item === true)) {
            return;
        }
        zoneStore.getZone(record).then(
				(result) => {
					setZone(result)
				}
			);
    }
	useEffect(() => { //load projectListFirst
		graphStore.getprojectList().then(i => {
			console.log(i)
			if (i) setProjectOptions(i)
		})
	}, [])

	useEffect(() => { //load projectListFirst
		graphStore.getlocationList(record.projectId).then(i => {
			if (i) {
				setLocationOptions(i)
			}
			setRecord({ ...record, locationId: -1})
		})

	}, [record.projectId])


	return (

		<div className="border-b-[4px] border-gray-400">
			<form className="w-full flex flex-col gap-3   h-full mt-2" >

				<div className="  flex lg:flex-row flex-col gap-3 justify-between items-center flex-wrap pb-2">

					<div className="w-full lg:w-auto grow">
						<SelectElement defValue={record.projectId} isWithApi={true} isRequired={errors.projectId} options={projectOptions} title={"Project"} name={"projectId"} setRecord={setRecord} record={record} />
					</div>
					<div className="w-full lg:w-auto grow">
						<SelectElement defValue={record.locationId} isWithApi={true} isRequired={errors.locationId} options={locationOptions} title={"Location"} name={"locationId"} setRecord={setRecord} record={record} onlyRead={record.projectId <= 0} />

					</div>
					<div  className='w-full lg:w-auto grow-0'><GeneralButton title={"View"} handleClick={handleUpdate} /></div>
					<div  className='w-full lg:w-auto grow-0'><GeneralButton disabled={true} title={"Update"} handleClick={handleUpdate} /></div>

				</div>
			</form>


		</div>

	)
})
